import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { GlobalService } from 'src/app/extensions/services/global.service';
import { ROUTES } from 'src/app/core/constants/routes-constants';
import { USER_ROLES } from 'src/app/extensions/constants/commonConstants';
import { ENV_CONFIG } from '../injection.token';

export const userRedirectResolver: ResolveFn<string> = () => {
  const _globalService = inject(GlobalService);
  const _envConfig = inject(ENV_CONFIG);

  if (_globalService.isAdminUser()) {
    return _envConfig.ADMIN_DEFAULT_ROUTE_URL ?? ROUTES.ADMIN_DEFAULT_ROUTE_URL;
  } else if (_globalService.user?.roles.includes(USER_ROLES.USER)) {
    if (_globalService.user?.userAllowedRoutes.find(x => x == ROUTES.DEFAULT_ROUTE_URL)) {
      return ROUTES.DEFAULT_ROUTE_URL;
    } else if (_globalService.user?.userAllowedRoutes.some(x => x)) {
      return _globalService.user?.userAllowedRoutes[0];
    }
  }

  return ROUTES.INVALID_ACCOUNT;
};
